import type { TypographyProps } from '@montugroup/design-system';
import { Typography } from '@montugroup/design-system';
import { useTheme } from '@mui/material';
import React from 'react';

interface PageHeadingProps extends TypographyProps {
  children: React.ReactNode;
}

export default function PageHeading({ children, ...typographyProps }: PageHeadingProps) {
  const theme = useTheme();

  return (
    <Typography
      variant="h5"
      sx={(theme) => ({ color: theme.palette.primary.main })}
      mb={theme.spacing(6)}
      {...typographyProps}
    >
      {children}
    </Typography>
  );
}
